import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { GetEventsByTeamIdParams } from './params'
import { useQuery } from '@tanstack/react-query'
import type { QueryHook } from '@/lib/react-query'
import { getEventsByTeamId } from './requests'
import type { Event } from '~shared/types'

export const eventQueryKeys = createQueryKeys('EVENT', {
  byTeamId: ({ teamId, ...params }: GetEventsByTeamIdParams) => [
    teamId,
    params,
  ],
})

export const useEventsByTeamId = ({
  params,
  options,
}: QueryHook<Event[], GetEventsByTeamIdParams>) => {
  return useQuery({
    ...options,
    queryKey: eventQueryKeys.byTeamId(params).queryKey,
    queryFn: async () => {
      const { data } = await getEventsByTeamId(params)

      return data
    },
  })
}
